import { render } from "./hpa-scaling-rule.vue?vue&type=template&id=361db61c"
import script from "./hpa-scaling-rule.vue?vue&type=script&lang=js"
export * from "./hpa-scaling-rule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__